import type { AppProfile } from '@appStore/reducers/app.types'

import { CONSTS } from 'config/objectConst'

type OnboardKey = keyof typeof CONSTS.ON_BOARDING

function isValidOnBoardingConditions(
	appProfile: null | Partial<AppProfile>,
	onBoardingNumber: OnboardKey
) {
	if (!appProfile) {
		return true
	}
	const conditions = CONSTS.ON_BOARDING[onBoardingNumber].conditions
	for (const key in conditions) {
		const typed = key as keyof typeof conditions
		if (conditions[typed] !== appProfile[typed]) {
			return false
		}
	}

	return true
}

export { isValidOnBoardingConditions }
